import { render } from "./SongView.vue?vue&type=template&id=4baf3af9&scoped=true"
import script from "./SongView.vue?vue&type=script&lang=js"
export * from "./SongView.vue?vue&type=script&lang=js"

import "./SongView.vue?vue&type=style&index=0&id=4baf3af9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4baf3af9"]])

export default __exports__